export const BASE_DELAY = 20;
export const BOOKINGS_CALENDAR_REFERRAL_INFO = 'booking_calendar_widget';
export const DESKTOP_WIDGET_MIN_WIDTH = 640;
export const MOBILE_WIDGET_MIN_WIDTH = 280;
